// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-builder-wrapper .form-container .add-option-button {
  color: #FF2459;
}
.question-builder-wrapper .question-modal .modal-container {
  height: 760px !important;
}

div:has(.question-modal-error) {
  bottom: 110px !important;
}`, "",{"version":3,"sources":["webpack://./src/routes/event-create/containers/step-3/components/question-builder/style.scss"],"names":[],"mappings":"AAEI;EACE,cAAA;AADN;AAKE;EACE,wBAAA;AAHJ;;AAOA;EACE,wBAAA;AAJF","sourcesContent":[".question-builder-wrapper {\n  .form-container {\n    .add-option-button {\n      color: theme('colors.primary');\n    }\n  }\n\n  .question-modal .modal-container {\n    height: 760px !important;\n  }\n}\n\ndiv:has(.question-modal-error) {\n  bottom: 110px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
